import { RollingDatePreset } from 'corso-types';
import { endOfDay, startOfDay, sub } from 'date-fns';
const presetDurations = {
    [RollingDatePreset.today]: {},
    [RollingDatePreset.last7Days]: { days: 7 },
    [RollingDatePreset.last30Days]: { days: 30 },
    [RollingDatePreset.last90Days]: { days: 90 },
    [RollingDatePreset.last12Months]: { months: 12 },
};
export const computeDateFilterValue = (value, now = new Date()) => {
    if (value.kind === 'preset') {
        return {
            start: startOfDay(sub(now, presetDurations[value.preset])).toISOString(),
            end: null,
        };
    }
    const start = value.range.start
        ? startOfDay(new Date(value.range.start)).toISOString()
        : null;
    const end = value.range.end
        ? endOfDay(new Date(value.range.end)).toISOString()
        : null;
    return { start, end };
};
const isViewDateValue = (value) => value !== null &&
    typeof value === 'object' &&
    'kind' in value &&
    (value.kind === 'preset' || value.kind === 'custom');
// Walks a view-shape filter record, swapping every `viewDateValue` entry for
// its resolved `{ start, end }`. Called by the API report orchestrator before
// dispatching to a pipeline so saved date presets recompute on every run.
export const resolveViewFilters = (filters) => Object.fromEntries(Object.entries(filters).map(([key, value]) => [
    key,
    isViewDateValue(value) ? computeDateFilterValue(value) : value,
]));
//# sourceMappingURL=viewDateFilter.js.map